import {
  RFID_FILE_UPLOAD_REQUEST,
  RFID_FILE_UPLOAD_SUCCESS,
  RFID_FILE_UPLOAD_FAILURE,
  RFID_FILE_UPLOAD_SET_SUBMITTED,
} from './types/RfidUploadActionsTypes';

export function uploadRfidFileRequestActionCreator(file, json) {
  return {
    type: RFID_FILE_UPLOAD_REQUEST,
    payload: { file, json },
  };
}

export function uploadRfidFileSuccessActionCreator(data) {
  return {
    type: RFID_FILE_UPLOAD_SUCCESS,
    payload: data,
  };
}

export function uploadRfidFileFailureActionCreator(error, validation) {
  return {
    type: RFID_FILE_UPLOAD_FAILURE,
    payload: { error, validation },
    error: true,
  };
}

export function uploadRfidfileSetSubmitted(submitted) {
  return {
    type: RFID_FILE_UPLOAD_SET_SUBMITTED,
    submitted,
  };
}
